import { render } from "./Loader.vue?vue&type=template&id=22760514&scoped=true&ts=true&lang=pug"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=22760514&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22760514"]])

export default __exports__